var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1089_6449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 9.33365C2.06971 9.33365 2.66667 8.7367 2.66667 8.00032C2.66667 7.26394 2.06971 6.66699 1.33333 6.66699C0.596954 6.66699 0 7.26394 0 8.00032C0 8.7367 0.596954 9.33365 1.33333 9.33365Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99983 9.33365C8.73621 9.33365 9.33317 8.7367 9.33317 8.00032C9.33317 7.26394 8.73621 6.66699 7.99983 6.66699C7.26346 6.66699 6.6665 7.26394 6.6665 8.00032C6.6665 8.7367 7.26346 9.33365 7.99983 9.33365Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 9.33365C15.4032 9.33365 16.0002 8.7367 16.0002 8.00032C16.0002 7.26394 15.4032 6.66699 14.6668 6.66699C13.9305 6.66699 13.3335 7.26394 13.3335 8.00032C13.3335 8.7367 13.9305 9.33365 14.6668 9.33365Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1089_6449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05);
export default __webpack_public_path__ + "static/media/05.8ff46d3c735f28df9ea94075d863e95c.svg";
export { ForwardRef as ReactComponent };